import { createContext } from "react";

var _createContext = /*#__PURE__*/createContext(null),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

export { Consumer, Provider };